import { useAuthStore } from "store";
import { LEVELS } from "utils/permissions";
import useGlobalStore from "store/global";
import { isModuleEnabledForCompany } from "utils/modulePreferences";

/**
 * Route guard that checks module-level permissions.
 * Wraps a child element and either renders it or shows a 403 / redirects to home.
 *
 * Usage:
 *   <RequirePerm module="MOD_BRAND" level={LEVELS.READ}>
 *     <BrandMaster />
 *   </RequirePerm>
 */
export default function RequirePerm({ module, level = LEVELS.READ, children }) {
  const hasAccess = useAuthStore((state) => state.hasAccess);
  const companyPreferences = useGlobalStore((state) => state.companyPreferences);

  if (
    isModuleEnabledForCompany(module, companyPreferences) &&
    hasAccess(module, level)
  ) {
    return children;
  }

  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">403</h1>
        <h2 className="text-lg font-semibold text-gray-700 mb-4">Access Denied</h2>
        <p className="text-sm text-gray-500 mb-6">
          You do not have permission to view this page.
          <br />
          Contact your company administrator to request access.
        </p>
        <a
          href="/"
          className="text-indigo-600 hover:text-indigo-500 font-medium text-sm"
        >
          ← Go to Home
        </a>
      </div>
    </div>
  );
}
